module.exports = __webpack_public_path__ + "f0e3ed7662482730913f5124dde2a384.svg";